/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Row } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';
import Thumb from '../thumb/Thumb';
import Typography from '../../shared/typography/Typography';
import colors from '../../../theme/colors';

import { useTranslation } from 'react-i18next';
import Button from '../../shared/button/Button';
import { ITalksProps } from '../../../interfaces/university/talk';

interface StyledSectionTalksProps {
  style?: any;
  color: string;
  colorBackground: string;
  wrap?: boolean;
}

export interface ISectionTalks {
  title: String | undefined;
  description?: string;
  style?: any;
  color: string;
  colorBackground: string;
  talks: ITalksProps[] | undefined;
  wrap?: boolean;
  slug?: string;
  owner?: string;
  apiUrl?: string;
  relationed?: boolean;
  showTalkStatus?: boolean;
  type?: 'subgroup' | 'group';
  enableLink?: boolean;
  url?: string;
  channel?: string;
  group_is_public?: boolean;
  user_is_subscribed?: boolean;
}
const DEFAULT_COLOR = 'darkBackground';

const StyledSectionTalks =
  styled.div<StyledSectionTalksProps>`
  background-color: ${(props) => props.colorBackground};
  text-align: initial;
  border-bottom: 1px solid ${(props) => props.theme.colors.line}; 
  padding: 48px 80px 10px 80px;

  @media only screen and (max-width: 768px){
    padding: 5px;
    padding-top: 40px;
  }

  .actions{
    display: flex;

    @media only screen and (max-width: 500px){
      align-self: flex-start;
    }

    .eventials-button{
      &:focus{
        border: 0px !important;
      }

      &.enabled:hover {
        .left-icon {
          background-color: ${(props) => props.theme.colors.placeholder};

          svg{
            path{
              fill: ${(props) => props.theme.colors.white};
            }
            rect{
              stroke: ${(props) => props.theme.colors.placeholder};
            }
          }
        }
      }

      &.disabled {
        .left-icon {
          opacity: 50%;
        }
      }

      &:hover{
        .left-icon{
          border-radius: 40px;
        }
      }

      .left-icon{
        margin-right: 10px;
      }
    }
  }

  .cardsRow{
    flex-direction: row;
    width: 100%;
    overflow-x: scroll;
    flex-wrap: nowrap;
    display: flex;
    height: 340px;
    scroll-behavior: smooth;
    gap: 24px;
    padding-left: 10px;

    ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
    height: 295px;
  }

    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
        }

  }

  .cardsBlock{
      justify-content: flex-start;
      max-width: 288px;
      gap: 8px;

      ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
        width: 230px;
      }
  }

  .header{
    margin-bottom: 0px;
    padding: 0;

    .title{
      padding: 20px 20px 20px 10px;
      display: flex;
      flex-direction: column;

      @media only screen and (max-width: 768px){
        padding: 5px;
      }
    }

    .actions{
      justify-content: flex-end;
      flex-direction:  row;

      @media only screen and (max-width: 768px){
        padding-top: 0px
      }
    }

    @media only screen and (max-width: 768px){
      margin-bottom: 20px;
    }
  }
`;


const SectionTalks = ({
  title,
  description,
  style,
  color,
  colorBackground,
  talks,
  wrap,
  slug,
  relationed,
  showTalkStatus,
  enableLink = false,
  channel,
  group_is_public,
  user_is_subscribed,
}: ISectionTalks) => {

  const [className, setClassName] = useState('cardsBlock');
  const scrollArea = useRef<HTMLDivElement>(null);
  const [selectedIndicator, setSelectedIndicator] = useState(0);
  const [totalShowCards, setTotalShowCards] = useState(0);

  const {t} = useTranslation();

  const history = useHistory();


  const handleCardWidth = () => {
    const isSmall = window.innerWidth < 768;
    const isLarge = window.innerWidth > 1440;
    let cardWidth = 320;

    if(isSmall){
      cardWidth = window.innerWidth - 10;
    }else if(isLarge){
      cardWidth = 380;
    }else{
      cardWidth = 320
    }

    return cardWidth;
  }

  const handleScroll = (n: any) => {
    let cardWidth = handleCardWidth();
    const scrollOffset = n * cardWidth;

    if (scrollArea.current !== null) {
      scrollArea.current.scrollLeft += scrollOffset;
    }
  };

  useEffect(() => {
    const cardWidth = handleCardWidth();
    const totalCards = Math.floor(window.innerWidth / cardWidth) - 1;

    setTotalShowCards(totalCards)
  }, []);

  useEffect(() => {
    if (wrap || wrap === undefined) {
      setClassName('cardsBlock');
    } else {
      setClassName('cardsRow');
    }
  }, [wrap]);

  useEffect(() => {
    if (scrollArea.current) {
      let timeout: any;
      scrollArea.current.onscroll = (evt: any) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          if (scrollArea.current) {
            const scrollOffset = scrollArea.current?.scrollLeft;
            const cardWidth = handleCardWidth();
            
            const totalCards = Math.floor(window.innerWidth / cardWidth) - 1;
            
            let selectedCalc = 0;
            
            if (scrollOffset % cardWidth > cardWidth / 2) {
              selectedCalc = Math.ceil(scrollOffset / cardWidth);
            } else {
              selectedCalc = Math.floor(scrollOffset / cardWidth);
            }
            
            // scrollArea.current.scrollLeft = selectedCalc * cardWidth;
            
            setTotalShowCards(totalCards)
            setSelectedIndicator(selectedCalc);
          }
        }, 1000);
      };
    }
  }, [scrollArea]);

  return (
    <StyledSectionTalks color={color} colorBackground={colorBackground} style={{ ...style }}>
      <Row className="header">
        <Col className="title" xxl={20} xl={14} lg={14} md={14} sm={12} xs={12} >
          {relationed && (
            <Typography type="heading6" style={{color: color, display: 'block', marginBottom: '16px'}}>
              {t('seeToo', 'veja também')}
            </Typography>
          )}
          <Typography type="heading5" color="title" >
            {enableLink
              ? <a href="#" onClick={(e) => {e.preventDefault(); history.push(`/${channel}/groups/${slug}`); }} target="_blank" style={{ color: colors.secondary }} rel="noreferrer">{title}</a> : <span>{title}</span>
            }
          </Typography>
        </Col>

        {className === 'cardsRow' && (
          group_is_public || user_is_subscribed ? (
              <Col
              xxl={{ span: 2, offset: 2 }}
              xl={{ span: 3, offset: 7 }}
              lg={{ span: 6, offset: 4 }}
              md={{ span: 6, offset: 4 }}
              sm={{ span: 10, offset: 2 }}
              xs={{ span: 10, offset: 2 }}
              className="actions"
            >
              <Button
                enable={selectedIndicator !== 0}
                className={selectedIndicator !== 0 ? 'enabled' : 'disabled'}
                variant="text"
                colorType="secondary"
                style={{ padding: 0, background: 'transparent' }}
                leftIcon={
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => handleScroll(-1)}
                    className="icon"
                  >
                    <path
                      d="M26.5122 19.0122L15.4783 19.0122L20.2988 14.1916C20.6841 13.8064 20.6841 13.1742 20.2988 12.7889C19.9136 12.4037 19.2912 12.4037 18.906 12.7889L12.3963 19.2987C12.011 19.6839 12.011 20.3062 12.3963 20.6915L18.8961 27.2111C19.0807 27.396 19.3312 27.5 19.5925 27.5C19.8538 27.5 20.1044 27.396 20.2889 27.2111C20.6742 26.8258 20.6742 26.2035 20.2889 25.8183L15.4783 20.9878L26.5122 20.9878C27.0555 20.9878 27.5 20.5433 27.5 20C27.5 19.4567 27.0555 19.0122 26.5122 19.0122Z"
                      fill={colors.secondary}
                    />
                    <rect
                      x="39.25"
                      y="39.25"
                      width="38.5"
                      height="38.5"
                      rx="19.25"
                      transform="rotate(-180 39.25 39.25)"
                      stroke={colors.secondary}
                      strokeWidth="1.5"
                    />
                  </svg>
                }
              />

              <Button
                enable={ talks ? (selectedIndicator <= (talks.length - totalShowCards) && (totalShowCards < talks.length)) : false}
                className={ talks ? (selectedIndicator <= (talks.length - totalShowCards) && totalShowCards < talks.length ? 'enabled' : 'disabled') : 'disable'}
                variant="text"
                colorType="secondary"
                style={{ padding: 0, background: 'transparent' }}
                leftIcon={
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => handleScroll(1)}
                    className="icon"
                  >
                    <path
                      d="M13.4878 20.9878L24.5218 20.9878L19.7012 25.8084C19.3159 26.1936 19.3159 26.8258 19.7012 27.2111C20.0864 27.5963 20.7088 27.5963 21.094 27.2111L27.6037 20.7013C27.989 20.3161 27.989 19.6938 27.6037 19.3085L21.1039 12.7889C20.9193 12.604 20.6688 12.5 20.4075 12.5C20.1462 12.5 19.8956 12.604 19.7111 12.7889C19.3258 13.1742 19.3258 13.7965 19.7111 14.1817L24.5218 19.0122L13.4878 19.0122C12.9445 19.0122 12.5 19.4567 12.5 20C12.5 20.5433 12.9445 20.9878 13.4878 20.9878Z"
                      fill={colors.secondary}
                    />
                    <rect
                      x="0.75"
                      y="0.75"
                      width="38.5"
                      height="38.5"
                      rx="19.25"
                      stroke={colors.secondary}
                      strokeWidth="1.5"
                    />
                  </svg>
                }
              />
            </Col>
          ) : (
            <Button 
              onClick={() => {history.push(`/${channel}/groups/${slug}`)}}
              size="medium"
              typographyType="button3"
              customBackground={color}
              style={{borderRadius: "30px", height: "45px", margin: "auto", marginRight: 0}}
              enable
            >
              {t("seeMore")}
            </Button>
          )
        )}
      </Row>
      <Row style={{marginBottom: '48px', paddingLeft: '10px'}}>
        <Typography type="body3" color="body">
          {description}
        </Typography>
      </Row>
      <Fade>
        {(group_is_public || user_is_subscribed) && 
        <Row className={className} ref={scrollArea}>
          {talks?.map((t: ITalksProps) => t.is_public && (
            <Col key={t.slug} md={10} lg={8} xl={6} xxl={5} className='cardsBlock'>
              <a target="_blank" href="#" onClick={(e) => {e.preventDefault(); history.push(`/${channel}/${t.slug}`)}} rel="noreferrer">
                <Thumb key={t.slug} object={t} color={color} showTag={showTalkStatus} state={t.state} />
              </a>
            </Col>
          ))}
        </Row>}
      </Fade>
    </StyledSectionTalks>
  );
};

SectionTalks.defaultProps = {
  colorBackground: DEFAULT_COLOR,
};

export default SectionTalks;
